<template>
  <div class="row item-container">
    <div class="row content-left">
      <el-checkbox class="checkout-box" v-model="data.checked" @change="checkedChange"></el-checkbox>
      <el-popover
        placement="right"
        popper-class="img-previewer"
        trigger="hover"
        :visible-arrow=false
        >
        <div class="content-container">
          <img class="big-img" :src="data.figureUrl">            
        </div>          
        <img slot="reference" class="img" :src="data.figureUrl">
      </el-popover>
      <div class="content-message">
        <div @click="toDetailPage(data.id)" class="title">{{data.title}}</div>
        <span class="text">{{data.body}}</span>
        <div class="source-institution">
          <span>发布时间: {{data.date}}</span>
          <span class="institution">机构: {{data.institution}}</span>
        </div>
      </div>
    </div>
    <div class="row content-right">
      <!-- <div class="date">{{data.date}}</div> -->
      <div @click="onDownload(data.link, data.title, data.institution, data.date)" class="download-img"></div>
      <div @click="onCollection" v-if="!data.collected && !showDel" class="collection-img"></div>
      <div @click="onUncollect" class="collected-img" v-if="data.collected && !showDel"></div>
      <div @click="onUncollect" v-if="showDel" class="delete1-img"></div>
    </div>
  </div>
</template>

<script>
import Mark from 'mark.js';
import QuestionQuery from '@/rest/questionQuery';
import authService from '@/services/authService';
import localStorageHelper from '@/helpers/localStorageHelper';
import { PDF_DETAIL_DATA } from '@/helpers/constants';

export default {
  data() {
    return {
      id: 0,
      checked: false
    };
  },
  props: {
    data: {
      type: Object
    },
    showDel: {
      type: Boolean
    }
  },
  methods: {
    checkedChange() {
      this.$emit('change');
    },
    onUncollect() {
      this.$emit('uncollect', this.data.id);
    },
    onDownload(url, title, institution, date) {
      // pdfDownloadHelper.downloadPdf(url, title);
      // this.$emit('download', this.data.id);
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit('unLogin');
      } else if (authService.getRole() === 'NOVIP') {
        eventBus.$emit('isVistor');
      } else {
        const downloadUrl = url.indexOf('?') === -1 ? url : url.replace(/\?/, '%3F');
        const fileName = title.replace(/[.|\\|/|*|?|"|<|>||]/g, '')
          .replace(/:/g, '：');
        if (downloadUrl.indexOf('.pdf') === -1) {
          message('没有找到相关资源，此PDF暂时无法下载', '错误提示', {
            confirmButtonText: '确定'
          });
        } else {
          this.$message({
            message: '正在下载...',
            duration: 2000,
            center: true
          });
          QuestionQuery.getPdfDownload(downloadUrl, fileName, institution, date).then(() => {

          },
          (err) => {
            if (err.status === 403) {
              this.$emit('noDownloadPermissions');
            }
          });
        }
      }
    },
    onCollection() {
      this.$emit('collection', { id: this.data.id });
    },
    toDetailPage(id) {
      if (!authService.whoIsLoggedIn()) {
        eventBus.$emit('unLogin');
      } else {
        this.id = id;
        eventBus.$emit('toPdfDetail');
        localStorageHelper.setItem(PDF_DETAIL_DATA, JSON.stringify(this.data));
        const routeUrl = this.$router.resolve('/pdf-detail');
        window.open(routeUrl.href, '_blank');
      }
    }
  },
  mounted() {
    if (this.$router.currentRoute.path !== '/' && this.data.highlight) {
      const titleInstance = new Mark(document.querySelectorAll('.title'));
      titleInstance.mark(this.data.highlight.title || [], {
        element: 'span',
        className: 'highlight'
      });
      const textInstance = new Mark(document.querySelectorAll('.text'));
      textInstance.mark(this.data.highlight.text || [], {
        element: 'span',
        className: 'highlight'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.item-container {
  justify-content: space-between;
  padding: 16px 0;
  box-shadow: inset 0px -1px 0px 0px#f2f3f7; 
  &:hover {
    background:rgba(250,250,252,1);
  } 
  .content-left {
    .checkout-box {
      vertical-align: top;
      margin-right: 18px;
    }
    .img {
      width: 113px;
      height: 84px;
      cursor: pointer;
      &:hover {
        border: solid 2px #2b76ff;
      }
    }
    .content-message {
      margin-left: 8px;
      .title {
        margin-bottom: 8px;
        color: #171f46;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #0055ff;
          text-decoration: underline;
        }
      }
      .text {
        padding: 0 8px;
        line-height: 22px;
        border-radius: 2px;
        color: #747990;
        background-color: #f2f3f7;
        font-size: 14px;
      }
      .source-institution {
        margin-top: 8px;
        font-size: 12px;
        color: #747990;
        .institution {
          margin-left: 16px;
        }
      }
    }
  }
  .content-right {
    height: 16px;
    color: #747990;
    font-size: 12px;
    // .download-img {
    //   margin:0 16px;
    //   cursor: pointer;
    // }
    // .collection-img {
    //   cursor: pointer;
    // }
    .download-img {
      margin:3px 16px 0;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background: url("../../assets/img/download.svg") no-repeat;
      background-size: cover;
      cursor: pointer;
      &:hover {
        background: url("../../assets/img/download-hover.svg") no-repeat;
      }
    }
    .collection-img {
      margin-top: 3px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background: url("../../assets/img/collection.svg") no-repeat;
      background-size: cover;
      cursor: pointer;
      &:hover {
        background: url("../../assets/img/collection-hover.svg") no-repeat;
      }
    }
    .collected-img {
      margin-top: 3px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background: url("../../assets/img/collected.svg") no-repeat;
      background-size: cover;
      cursor: pointer;
    }
    .delete1-img {
      margin-top: 3px;
      width: 16px;
      height: 16px;
      line-height: 16px;
      background: url("../../assets/img/delete1.svg") no-repeat;
      background-size: cover;
      cursor: pointer;
      &:hover {
        background: url("../../assets/img/delete1-hover.svg") no-repeat;
      }
    }
  }
}
/deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #2b76ff;
  border-color: #2b76ff;
}
</style>

<style lang="scss">
  .el-popover.img-previewer {
    box-shadow: 0px 6px 10px 0px rgba(10, 31, 68, 0.1);
    border: solid 2px #2b76ff;
    .content-container {
      .big-img {
        display: block;
        margin: 0 auto;
        max-width: 520px !important;
        max-height: 368px !important;
      }
    }
  }
</style>
